import { render, staticRenderFns } from "./other_url.vue?vue&type=template&id=442f031f&scoped=true&"
import script from "./other_url.vue?vue&type=script&lang=js&"
export * from "./other_url.vue?vue&type=script&lang=js&"
import style0 from "./other_url.vue?vue&type=style&index=0&id=442f031f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442f031f",
  null
  
)

export default component.exports